module.exports = __webpack_public_path__ + "static/media/icra24yokohama.5c988cc9.jpeg";